export interface logTrackingEntry {
  comment: string
  gtmEvent: any
  ffEvent: any
}

export function logTrackingFromServerResponse(entries: logTrackingEntry[] | null | void | undefined) {
  if (entries) {
    entries.forEach((item) => {
      logTracking("[Server] " + item.comment, item.gtmEvent, item.ffEvent)
    })
  }
}

export function logTracking(comment: string, gtmEvent: any, ffEvent: any) {
}
